import packageInfo from '../../package.json';

export const environment = {
  production: false,
  env: 'dev',
  ticketsurl: 'https://gitlab.elbuild.com/yf-commerce/unisafety-tickets',
  proxy: 'ws/',
  externalapi: undefined,
  appVersion: packageInfo.version,
  title: 'Unisafety DEV',
  langs: [
    { code: 'it', name: 'Italiano', flag: 'it' }
  ],
  defaultlang: 'it',
  notifications: false,
  svglogo: undefined,
  imagelogo: '/assets/images/logo/logo-us.png',
  logodark: '/assets/images/logo/logo-us.png',
  themeconfig: {
    layout: 'vertical', // vertical, horizontal, compact
    isDarkMode: 'light',  // light, dark, auto-mode
    theme_color: 'yellow-theme',// blue-theme, indigo-theme, purple-theme, pink-theme, red-theme, orange-theme, yellow-theme, green-theme, teal-theme, cyan-theme
    isRtlLayout: false, // false true
    isBox_container: false, // false true
    theme_contrast: false, //true false
    menu_caption: false, // true false
  },
  stripeurl: 'https://dashboard.stripe.com/payments/',
  showcredit: false,
  b2b: false,
  showvat: true,
  billingtypes: { 0: true, 1: true, 2: true }, //0 : individual, 1: company, 2: association
  defaultcountry: 'Italia',
  onlydefaultcountry: false,
  i18n: true,
  cdnurl: 'https://cdn.yellowfincommerce.com/',
  cardactive: false,
  storecode: 'unisafety',
  shipmentclassextra: false,
  deltaprice: false,
  hasleftmenu: true,
  hide: ['influencer']
};

